// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { Injectable, Injector } from '@angular/core'; //_splitter_
import { MatSnackBar } from '@angular/material/snack-bar'; //_splitter_
import { Router } from '@angular/router'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
//append_imports_end

declare const window: any;
declare const cordova: any;

@Injectable({
  providedIn: 'root',
})
export class DataService {
  public url: any;
  public body: any;

  constructor(
    private sdService: SDBaseService,
    private router: Router,
    private matSnackBar: MatSnackBar,
    private __service_injector__: Injector
  ) {
    this.registerListeners();
  }
  private registerListeners() {
    let bh = this.sdService.__constructDefault({});

    //append_listeners
  }

  //   service flows_DataService

  async postMethod(url = '', body: any = undefined, ...others) {
    let bh: any = {
      input: {
        url,
        body,
      },
      local: {
        result: undefined,
      },
    };
    try {
      bh = this.sdService.__constructDefault(bh);

      bh = await this.sd_PiovIOMPCqTJessp(bh);
      //appendnew_next_postMethod
      return (
        // formatting output variables
        {
          input: {},
          local: {
            result: bh.local.result,
          },
        }
      );
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_5nhu5li6V7Y4EeXx');
    }
  }

  async getMethod(url = '', ...others) {
    let bh: any = {
      input: {
        url,
      },
      local: {
        result: undefined,
      },
    };
    try {
      bh = this.sdService.__constructDefault(bh);

      bh = await this.sd_fQm8JJSijgZOLH2a(bh);
      //appendnew_next_getMethod
      return (
        // formatting output variables
        {
          input: {},
          local: {
            result: bh.local.result,
          },
        }
      );
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_TSCetTVg0pq6EcIC');
    }
  }

  async deleteMethod(url = '', body: any = undefined, ...others) {
    let bh: any = {
      input: {
        url,
        body,
      },
      local: {
        result: undefined,
      },
    };
    try {
      bh = this.sdService.__constructDefault(bh);

      bh = await this.sd_WQ0Vt6w9S6GIeFEI(bh);
      //appendnew_next_deleteMethod
      return (
        // formatting output variables
        {
          input: {},
          local: {
            result: bh.local.result,
          },
        }
      );
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_UnAI1VZ8E4lssv9o');
    }
  }
  //appendnew_flow_DataService_start

  async sd_PiovIOMPCqTJessp(bh) {
    try {
      bh.local.url = bh.system.environment.properties.ssdURL + bh.input.url;
      bh = await this.sd_wUIZYvdh7RWigoge(bh);
      //appendnew_next_sd_PiovIOMPCqTJessp
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_PiovIOMPCqTJessp');
    }
  }

  async sd_wUIZYvdh7RWigoge(bh) {
    try {
      let requestOptions = {
        url: bh.local.url,
        method: 'post',
        responseType: 'json',
        headers: bh.headers,
        params: {},
        body: bh.input.body,
        withCredentials: true,
      };
      bh.local.result = await this.sdService.nHttpRequest(requestOptions);
      bh = await this.resetRequestData(bh);
      //appendnew_next_sd_wUIZYvdh7RWigoge
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_wUIZYvdh7RWigoge');
    }
  }

  async resetRequestData(bh) {
    try {
      this.url = '';
      this.body = {};
      //appendnew_next_resetRequestData
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_BhbzpQ0Xg52rveQS');
    }
  }

  async sd_fQm8JJSijgZOLH2a(bh) {
    try {
      bh.local.url = bh.system.environment.properties.ssdURL + bh.input.url;

      bh = await this.sd_L1rh7KguduSBeqaY(bh);
      //appendnew_next_sd_fQm8JJSijgZOLH2a
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_fQm8JJSijgZOLH2a');
    }
  }

  async sd_L1rh7KguduSBeqaY(bh) {
    try {
      let requestOptions = {
        url: bh.local.url,
        method: 'get',
        responseType: 'json',
        headers: bh.headers,
        params: {},
        body: bh.input.body,
      };
      bh.local.result = await this.sdService.nHttpRequest(requestOptions);
      bh = await this.resetData(bh);
      //appendnew_next_sd_L1rh7KguduSBeqaY
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_L1rh7KguduSBeqaY');
    }
  }

  async resetData(bh) {
    try {
      this.url = '';
      this.body = {};
      //appendnew_next_resetData
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_T9gKmMrbTzzERwGZ');
    }
  }

  async sd_WQ0Vt6w9S6GIeFEI(bh) {
    try {
      bh.local.url = bh.system.environment.properties.ssdURL + bh.input.url;

      bh = await this.sd_lZpjqksIErcLEcnG(bh);
      //appendnew_next_sd_WQ0Vt6w9S6GIeFEI
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_WQ0Vt6w9S6GIeFEI');
    }
  }

  async sd_lZpjqksIErcLEcnG(bh) {
    try {
      let requestOptions = {
        url: bh.local.url,
        method: 'delete',
        responseType: 'json',
        headers: bh.headers,
        params: {},
        body: bh.input.body,
      };
      bh.local.result = await this.sdService.nHttpRequest(requestOptions);
      bh = await this.reset(bh);
      //appendnew_next_sd_lZpjqksIErcLEcnG
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_lZpjqksIErcLEcnG');
    }
  }

  async reset(bh) {
    try {
      this.url = '';
      this.body = {};
      //appendnew_next_reset
      return bh;
    } catch (e) {
      return await this.errorHandler(bh, e, 'sd_VgBtCdHI80bA6CZi');
    }
  }

  //appendnew_node

  // error_handler_slot
  private async errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_DataService_Catch
}
